import {ChangeDetectorRef, Component} from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import {environment} from "../../../environments/environment";
import {OrderType} from "../../../smoothr-web-app-core/enums/OrderType";
import {Location} from "@angular/common";

@Component({
	selector: 'app-order-type-selection',
	templateUrl: './order-type-selection.component.html',
	styleUrl: './order-type-selection.component.scss',
})
export class OrderTypeSelectionComponent {
	static url = 'order-type';
	loading = false;
	selectedPreorderType: PreorderType;

	constructor(
		public navigationService: NavigationService,
		private repositoryService: RepositoryService,
		private cdr: ChangeDetectorRef,
		public location: Location) {}

	async navigateToMenu(type: PreorderType) {
		this.loading = true;
		this.cdr.detectChanges()
		this.repositoryService.defaultPreorderType$.next(type);
		const v = await this.repositoryService.getVenue(environment.defVenue);
		this.repositoryService.createOrder(this.repositoryService._venue, null, OrderType.PREORDER, type);
		this.loading = false;
		await this.navigationService.map()
	}

	protected readonly PreorderType = PreorderType;
	protected readonly window = window;
}
